<template>
  <div class="main">
    <div class="head">
      <div class="title">{{ title || 'MOVE 上海市职工健康服务平台' }}</div>
    </div>
    <div class="con">
      <div class="left">
        <div class="top">
          <left-top :data="{ all_user, last_week_user, today_user, week_chain, week_user, company_num }" />
        </div>
        <div class="middle">
          <div class="c-title">性别比例</div>
          <left-middle v-if="level.length" :sex_detail="sex_detail" />
        </div>
        <div class="bottom">
          <div class="c-title">职工体质综合评级</div>
          <left-bottom v-if="level.length" :cData="level" />
        </div>
      </div>
      <div class="center">
        <div class="top">
          <div class="c-title">职工体质单项达标率 <span>% 为合格率</span></div>
          <middle-top :source-data="physical" />
        </div>
        <div class="bottom">
          <div class="c-title">驿站体测排行榜</div>
          <middle-bottom v-if="stadium_ranking.length" :list="stadium_ranking" />
        </div>
      </div>
      <div class="right">
        <div class="top">
          <div class="c-title">年龄段参与率情况分布</div>
          <right-top v-if="age_group.length" :age_group="age_group" />
        </div>
        <div class="bottom">
          <div class="c-title">运动处方分布</div>
          <right-bottom v-if="advice.length" :advice="advice" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import leftTop from './left-top.vue'
import leftMiddle from './left-middle.vue'
import leftBottom from './left-bottom.vue'
import middleTop from './middle-top.vue'
import middleBottom from './middle-bottom.vue'
import rightTop from './right-top.vue'
import rightBottom from './right-bottom.vue'

import api from '@/api'

export default {
  components: { leftTop, leftMiddle, leftBottom, middleTop, middleBottom, rightTop, rightBottom },

  data() {
    return {
      title: '',
      // left-top
      all_user: 0,
      last_week_user: 0,
      today_user: 0,
      week_chain: 0,
      week_user: 0,
      company_num: 0,
      // left-middle
      sex_detail: [],
      // left-bottom
      level: [],
      // middle-top
      physical: [],
      // middle-botto v-if=""m
      stadium_ranking: [],
      // right-top
      age_group: [],
      // right-bottom
      advice: [],
    }
  },
  mounted() {
    this.get_data()

    itimer = setInterval(() => {
      this.get_data()
    }, 60000)
  },
  methods: {
    get_data() {
      // api.common.indexData({ stid: this.$route.query.stid, gid: 'eStBcUhqZ0ZvRE09' }).then((r) => {
      //   Object.keys(r.data).forEach((key) => {
      //     this[key] = r.data[key]
      //   })
      // })
      const query = this.$route.query

      api.common.provinceData({ ...query, stid: this.$route.query.stid, gid: 'eStBcUhqZ0ZvRE09' }).then((r) => {
        let arr = []

        Object.keys(r.data.level).forEach((key) => {
          const obj = {
            item: key,
            count: r.data.level[key] * 1,
          }

          // if (key == '不合格') {
          //   // obj.item = '待提高'
          //   obj.count = 9
          // }

          // if (key == '优秀') {
          //   obj.count = 30
          // }

          arr.push(obj)
        })

        r.data.level = arr

        arr = []

        Object.keys(r.data.advice).forEach((key) => {
          arr.push({
            item: key,
            count: r.data.advice[key],
          })
        })

        r.data.advice = arr

        arr = []

        Object.keys(r.data.age_group).forEach((key) => {
          arr.push({
            item: key,
            percent: r.data.age_group[key].qualified_rate * 1,
          })
        })

        r.data.age_group = arr

        arr = {}

        r.data.sex_detail.forEach((row) => {
          if (row.gender == '男') {
            arr.male = row
          }
          if (row.gender == '女') {
            arr.female = row
          }
        })

        r.data.sex_detail = arr

        Object.keys(r.data).forEach((key) => {
          this[key] = r.data[key]
        })
      })
    },
  },
}
</script>

<style lang="less" scoped>
.main {
  padding: 0 42px;
  background: #001f5d;
  height: 100vh;
  width: 100vw;
  overflow: hidden;
  .head {
    width: 100%;
    height: 100px;
    background: url(../../../assets/gonghui/head-bg.png) no-repeat top center / 100% 100%;
    display: flex;
    justify-content: center;
    margin-bottom: 8px;
    .title {
      font-size: 40px;
      font-weight: 500;
      margin-top: 12px;
      color: #b6d0ff;
      text-align: center;
    }
  }
  .con {
    display: flex;
    align-items: center;
    .c-title {
      padding: 10px 0px 16px;
      margin: 0 24px;
      font-size: 22px;
      color: #a5d4ff;
    }
    .left {
      .top {
        width: 484px;
        height: 308px;
        background: url(../../../assets/province/bg-l-t.png) no-repeat center center / cover;
      }
      .middle {
        width: 484px;
        height: 290px;
        margin-top: 20px;
        background: url(../../../assets/province/bg-l-m.png) no-repeat center center / cover;
        .c-title {
          background: url(../../../assets/province/line-1.png) no-repeat center bottom / contain;
        }
      }
      .bottom {
        width: 484px;
        height: 308px;
        margin-top: 20px;
        background: url(../../../assets/province/bg-l-b.png) no-repeat center center / cover;
        .c-title {
          background: url(../../../assets/province/line-1.png) no-repeat center bottom / contain;
        }
      }
    }
    .center {
      padding: 0 20px;
      .c-title {
        background: url(../../../assets/province/line-2.png) no-repeat center bottom / contain;
      }
      .top {
        .c-title {
          display: flex;
          align-items: center;
          justify-content: space-between;
          span {
            font-size: 14px;
            color: #fff;
          }
        }
        width: 828px;
        height: 468px;
        background: url(../../../assets/province/bg-c-t.png) no-repeat center center / cover;
      }
      .bottom {
        width: 828px;
        height: 458px;
        margin-top: 20px;
        background: url(../../../assets/province/bg-c-b.png) no-repeat center center / cover;
      }
    }
    .right {
      .c-title {
        background: url(../../../assets/province/line-1.png) no-repeat center bottom / contain;
      }
      .top {
        width: 484px;
        height: 468px;
        background: url(../../../assets/province/bg-r-t.png) no-repeat center center / cover;
      }
      .bottom {
        width: 484px;
        height: 458px;
        margin-top: 20px;
        background: url(../../../assets/province/bg-r-t.png) no-repeat center center / 100% 100%;
      }
    }
  }
}
</style>
